// src/utils/dashboard.js

// calculează intervalul de timp pentru Dashboard
export const getTimeWindowDP = (timeRange, customStartDate, customEndDate) => {
  const now = new Date();
  let startDate, endDate;

  switch (timeRange) {
    case "month":
      startDate = new Date(now.getFullYear(), now.getMonth(), 1);
      endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      break;
    case "year":
      startDate = new Date(now.getFullYear(), 0, 1);
      endDate = new Date(now.getFullYear(), 11, 31);
      break;
    case "custom":
      startDate = customStartDate ? new Date(customStartDate) : new Date("2000-01-01");
      endDate = customEndDate ? new Date(customEndDate) : new Date();
      break;
    default:
      startDate = new Date("2000-01-01");
      endDate = new Date();
  }

  return { startDate, endDate };
};

// rezolvă numele șoferului
export const resolveDriverName = (dp, drivers) => {
  if (dp.driverId && typeof dp.driverId === "object" && (dp.driverId.firstName || dp.driverId.lastName)) {
    return `${dp.driverId.firstName || ""} ${dp.driverId.lastName || ""}`.trim() || "Unknown Driver";
  }
  const id = (dp.driverId && dp.driverId._id) || dp.driverId;
  const found = (drivers || []).find(d => String(d._id) === String(id));
  return found ? `${found.firstName || ""} ${found.lastName || ""}`.trim() : "Unknown Driver";
};
